import React, {useState, useEffect} from 'react';
import { createRoot } from 'react-dom/client'
import { paginate } from "../../utils/paginate";
import { animateScroll } from "react-scroll";
import {multiIncludes} from '../../utils/helpers';
import moment from 'moment';
import loadable from '@loadable/component'
const Filters = loadable(() => import('./filters/filters'));
const SmartwatchBox = loadable(() => import('../devices/smartwatchBox'));
const DeviceBox = loadable(() => import('../devices/deviceBox'));
const MediaPlayerBox = loadable(() => import('./mediaPlayerBox'));
const HeadphoneBox = loadable(() => import('./headphoneBox'));
const Pagination = loadable(() => import('../pagination/pagination'));
const DialogCompareList = loadable(() => import('../devices/dialogCompareList'));
// import DeviceBox from '../devices/deviceBox';
// import SmartwatchBox from '../devices/smartwatchBox';
// import DialogCompareList from '../devices/dialogCompareList';
// import Filters from './filters/filters'; 
// import Pagination from '../pagination/pagination';
// import MediaPlayerBox from './mediaPlayerBox';
// import HeadphoneBox from './headphoneBox';


const Results = ({type, defaultfilters}) => {
    const [devices, setDevices] = useState([]);
    const [items, setItems] = useState([]);
    const [searchStatus, setSearchStatus] = useState('pending');
    const [devicesFiltered, setDevicesFiltered] = useState([]);
    const [dataFilters, setDataFilters] = useState([]);
    const [appFilters, setAppFilters] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [compareDevices, setCompareDevices] = useState([]);
    const [orderBy, setOrderBy] = useState((type == 'smartwatches') ? 'id' : 'oficially_announced')
    const [orderByDir, setOrderByDir] = useState('desc')
    const [open, setOpen] = useState(false);
    const [nbActiveFilters, setNbActiveFilters] = useState(0);
    const [resetClick, setResetClick] = useState(false);
    const [totalItems, setTotalItems] = useState(0);   
    const pageSize = 24;


    useEffect(() => {
        const url = '/api/data/devices/results/' + type;
        axios.get(url)
        .then( res => {
            setDevices(res.data.devices);
            setTotalItems(res.data.devices.length);
            setDevicesFiltered(res.data.devices);
            setDataFilters(res.data.dataFilters);
            setSearchStatus('finished');
            setItems(paginate(_.cloneDeep(res.data.devices), currentPage, pageSize));
            // Set and save defaultFilters json comming from Php
            if(typeof defaultfilters !== undefined && defaultfilters != '' )
            {
                let f = _.cloneDeep(res.data.dataFilters);    
                _.forEach( JSON.parse(defaultfilters), (value, filterName) => {
                    if(filterName == 'manufacturers')
                        f.manufacturers = value                 
                    else{
                        _.forEach(value,  function(val, key){
                            if(Math.abs(val) > f[filterName]['last']) val = f[filterName][key];
                            f[filterName][key] = Math.abs(val);
                        })
                    }
                })
                setAppFilters(f);
            }
        })
        .catch(err => {
            console.log(err)
        });
    }, []);

    useEffect(() => {
        //Apply user filters to devices list
        getNbActiveFilters();
        applyFilters();
        

     }, [appFilters, currentPage, orderBy, orderByDir]);

     
    const checkInput = (input, words) => {
        return words.some(word => input.toLowerCase().includes(word.toLowerCase()));
    }
     
    /**
     * Method to apply filters and update devices to display
     * 
     *  RANGES
     *  -------------
     *  budget
     *  screen_display
     *  screen_resolution
     *  battery_capacity
     *  battery_charge_speed_wired
     *  battery_charge_speed_wireless
     *  camera_main
     *  camera_front
     *  ram
     *  stora*ge
     * 
     *  Checkboxes
     *  -------------
     *  resistance
     *  manufacturers
     *  camara_nb
     *  camara_video_recording
     * 
     */
    const applyFilters = () => {
        let filtered = devices;
        //prettier-ignore
        if (!_.isEmpty(appFilters)) {
            
            const keyMatch = {
                "oficially_announced" : "oficially_announced",
                "budget" : "lowest_price",
                "rate" : "rating",
                "screen_display" : "size_val",
                "screen_resolution" : "resolution_val",
                "battery_capacity" : "capacity_val",
                "battery_charge_speed_wired" : "max_charge_speed_wired",
                "battery_charge_speed_wireless" : "max_charge_speed_wireless",
                "camera_main" : "main_camera_val",
                "camera_front" : "front_val",
                "ram" : "ram_val",
                "storage" : "internal_storage_val",
            };
            
            Object.keys(appFilters).map(function (key) {
                //TO mange checkbox list appFilters
                let allChecked = [];
                if (appFilters[key] !== null) {
                    if(
                        key == "resistance" ||
                        key == "headphone_type" ||
                        key == "manufacturers" ||
                        key == "sensores" || 
                        key == "ids" ||
                        key == "camara_nb" ||
                        key == "camara_video_recording" ||
                        key == "headphone_type"
                    ){
                        filtered = group1(key, filtered, allChecked);
                    }
                    else if (
                        key == "acelerometro" ||
                        key == "altimetro" ||
                        key == "barometro" ||
                        key == "geomagnetico" ||
                        key == "giroscopio" ||
                        key == "luz_ambiental" ||
                        key == "oxigeno" ||
                        key == "nfc" ||
                        key == "brujula" ||
                        key == "termometro" ||
                        key == "presion_arterial" ||
                        key == "ritmo_cardiaco"
                    ){
                        if (appFilters[key] === true) {
                            allChecked = getSensorAlternativeValues(key);
                            filtered = filtered.filter(f => {
                                if(typeof f.sensors !== 'undefined' && f.sensors !== null)
                                    return checkInput(f.sensors, allChecked);
                            });
                        }
                    }
                    else if (
                        key == 'water_resistant' ||
                        key == 'connectivity_4g' ||
                        key == 'connectivity_3g' ||
                        key == 'music' ||
                        key == 'gps' ||
                        // ------- Headphones ----
                        key == 'usb' ||
                        key == 'water_resistant' ||
                        key == 'microphone' ||
                        key == 'bluetooth' ||
                        key == 'monaural' ||
                        key == 'inline_remote' ||
                        key == 'deep_bass'
                    ){
                        if (appFilters[key] === true) {
                            
                            filtered = filtered.filter(f => {
                                if(typeof f[key] !== 'undefined' && f[key] !== null)
                                    return (_.includes(f[key].toLowerCase() , 'si'))
                            });
                        }
                    }
                    else if ( _.includes(['r4k','hdr','dolbyvision','asistente','netflix','primevideo','appletv','hbomax','hulu','movistar','disney'], key)
                    ) {
                        if (appFilters[key] === true) {
                            filtered = filtered.filter(f => {
                                if(typeof f[key] !== 'undefined' && f[key] !== null)
                                    return f[key] == true;
                            });
                        }
                    }
                    else if ( key == 'dolbyatmos') {
                        if (appFilters[key] === true) {
                            filtered = filtered.filter(f => {
                                if(typeof f['audio'] !== 'undefined' && f['audio'] !== null)
                                    return (_.includes(f['audio'].toLowerCase() , 'dolby atmos'))
                            });
                        }
                    }
                    else if (key == 'priceStatus') {
                        if (appFilters[key] !== 'all') {
                            filtered = filtered.filter(f => {
                                return f[`lowest_price_${appFilters[key]}`] > 0
                            });
                        } 
    
                    }
                    else if (key == 'wifi6') {
                        if (appFilters[key] === true) {
                            filtered = filtered.filter(f => {
                                if(typeof f['wifi'] !== 'undefined' && f['wifi'] !== null)
                                    return (_.includes(f['wifi'].toLowerCase() , 'wi-fi 6') || _.includes(f['wifi'].toLowerCase() , 'wifi 6'))
                            });
                        }
                    }
                    else{
                        if (dataFilters[key].first != appFilters[key].first || dataFilters[key].last != appFilters[key].last){
                            
                           
                            filtered = filtered.filter(f => {
                                
                                if(f[keyMatch[key]] !== undefined){
                                    // This is to exclude all device without a price
                                    if(key == 'budget' && dataFilters[key].last > 1 && dataFilters[key].first == 0) {
                                        let keyVal = keyMatch[key];
                                        if(appFilters.priceStatus != 'all'){
                                            keyVal += '_' + appFilters.priceStatus;
                                        }
                                        if (f[keyVal] > appFilters[key].first && f[keyVal] <= appFilters[key].last)
                                            return true;
                                    }
                                    else if(key == 'oficially_announced') {
                                        if (parseInt(moment(f[keyMatch[key]]).format('YYYY')) >= appFilters[key].first && parseInt(moment(f[keyMatch[key]]).format('YYYY')) <= appFilters[key].last)
                                            return true;
                                    }
                                    else{
                                        if (f[keyMatch[key]] >= appFilters[key].first && f[keyMatch[key]] <= appFilters[key].last)
                                            return true;
                                    }
                                    
                                }
                            });
                        }
                    }
                }
            });
        }
        let sorted = [];
        if(orderBy == 'oficially_announced') 
            sorted = _.orderBy(filtered,  function(orderBy) {return new Date(orderBy);}, orderByDir);
        else if(orderBy.includes("lowest_price"))
        {
            //Remove lowest_price == null
            filtered = filtered.filter(f => (f.lowest_price > 0) ? true : false);
            if(appFilters.priceStatus !== 'all')
                sorted = _.orderBy(filtered, `lowest_price_${appFilters.priceStatus}`, orderByDir);
            else 
                sorted = _.orderBy(filtered, orderBy, orderByDir);
        }
        else
            sorted = _.orderBy(filtered, orderBy, orderByDir);
        
        setTotalItems(sorted.length)
        setDevicesFiltered(sorted);
        
        setItems(paginate(sorted, currentPage, pageSize));
    }


    const group1 = (key, filtered, allChecked) => {
        const nbAppFilters = appFilters[key].length;
        const nbDataFilters = dataFilters[key].length;
        if (nbAppFilters != nbDataFilters) 
        {
            switch (key) {
                case "headphone_type":
                    appFilters[key].map((v, i) =>  allChecked.push(v.id));
                    appFilters[key].map((v, i) => {
                        filtered = filtered.filter(f => multiIncludes(f.headphone_type, allChecked));
                    });
                    break;

                case "resistance":
                    appFilters[key].map((v, i) =>  allChecked.push(v.id));
                    appFilters[key].map((v, i) => {
                        filtered = filtered.filter(f => multiIncludes(f.resistance, allChecked));
                    });
                    break;

                case "manufacturers":
                    appFilters[key].map((v, i) =>  allChecked.push(v.id));
                    appFilters[key].map((v, i) => {
                        filtered = filtered.filter(f =>_.includes(allChecked, f.manufacturer_id));
                    });
                    break;

                case "sensores":
                    appFilters[key].map((v, i) =>  allChecked.push(v.label.toLowerCase()));
                    allChecked =  addSensorsPossibleValues(allChecked);
                    appFilters[key].map((v, i) => {
                        filtered = filtered.filter(f => {
                            if(typeof f.sensors !== 'undefined' && f.sensors !== null)
                                return checkInput(f.sensors, allChecked);
                            else return false;
                        });
                    });
                break;

                case "ids":
                    appFilters[key].map((v, i) =>  allChecked.push(v.id));
                    appFilters[key].map((v, i) => {
                        filtered = filtered.filter(f =>_.includes(allChecked, f.id));
                    });
                    break;
                
                case "camara_nb":
                    appFilters[key].map((v, i) =>  allChecked.push(v.label));
                    appFilters[key].map((v, i) => {
                        filtered = filtered.filter(f =>_.includes(allChecked, f.rear));
                    });
                    break;
                case "camara_video_recording":
                    appFilters[key].map((v, i) =>  allChecked.push(v.id));
                    
                    appFilters[key].map((v, i) => {
                        filtered = filtered.filter(f => (new RegExp(allChecked.join("|")).test(f.video_recording)) );
                    });
                    break;
            }
        }
        return filtered;
    }

    const getSensorAlternativeValues = (ref) => {
        let values = [];
        if(ref == 'acelerometro') values.push('acelerómetro', 'aceleración');
        if(ref == 'altimetro') values.push('altímetro', 'altitud');
        if(ref == 'barometro') values.push('barómetro', 'sensor de presión', 'barométrico');
        if(ref == 'geomagnetico') values.push('geomagnético', 'magnetómetro');
        if(ref == 'giroscopio') values.push('giroscopio', 'giroscópico');
        if(ref == 'luz_ambiental') values.push('luz ambiental', 'luz');
        if(ref == 'oxigeno') values.push('oxígeno', 'spO2', 'vo2máx');
        if(ref == 'presion_arterial') values.push('presión arterial', 'arterial', 'tensiómetro');
        if(ref == 'ritmo_cardiaco') values.push('ritmo cardíaco', 'pulsómetro', 'cardíaca', 'cardíaco', 'corazón');
        if(ref == 'nfc') values.push('nfc');
        if(ref == 'brujula') values.push('brújula');
        if(ref == 'termometro') values.push('termómetro');
        return values;
    }
    const addSensorsPossibleValues = (allChecked) => {
        /**
         * 
            ['label'=>'Acelerómetro'], aceleración
            ['label'=>'Altímetro'],
            ['label'=>'Barómetro'], "Sensor de presión", "barométrico"
            ['label'=>'Brújula'],
            ['label'=>'Geomagnético'], "magnetómetro"
            ['label'=>'Giroscopio'], "giroscópico"
            ['label'=>'GPS'],
            ['label'=>'Luz ambiental'], "luz"
            ['label'=>'NFC'],
            ['label'=>'Oxígeno'],
            ['label'=>'Presión arterial'],
            ['label'=>'Ritmo cardíaco'],  "Pulsómetro", "cardíaca", "cardíaco", "Corazón"
            ['label'=>'Termómetro']
        */
        if(_.includes(allChecked, "acelerómetro")){
            if(!allChecked.includes("aceleración")) allChecked.push("aceleración");
        }
        if(_.includes(allChecked, "barómetro")) {
            if(!allChecked.includes("sensor de presión")) allChecked.push("sensor de presión");
            if(!allChecked.includes("barométrico")) allChecked.push("barométrico");
        }
        if(_.includes(allChecked, "geomagnético")){
            if(!allChecked.includes("magnetómetro")) allChecked.push("magnetómetro");
        }
        if(_.includes(allChecked, "giroscopio")){
            if(!allChecked.includes("giroscópico")) allChecked.push("giroscópico");
        }
        if(_.includes(allChecked, "luz ambiental")){
            if(!allChecked.includes("luz")) allChecked.push("luz");
        }
        if(_.includes(allChecked, "oxígeno")){
            if(!allChecked.includes("spO2")) allChecked.push("spO2");
            if(!allChecked.includes("vo2máx")) allChecked.push("vo2máx");
        }
        if(_.includes(allChecked, "presión arterial")){
            if(!allChecked.includes("arterial")) allChecked.push("arterial");
            if(!allChecked.includes("tensiómetro")) allChecked.push("tensiómetro");
        }
        if(_.includes(allChecked, "ritmo cardíaco")){
            if(!allChecked.includes("pulsómetro")) allChecked.push("pulsómetro");
            if(!allChecked.includes("cardíaca")) allChecked.push("cardíaca");
            if(!allChecked.includes("cardíaco")) allChecked.push("cardíaco");
            if(!allChecked.includes("corazón")) allChecked.push("corazón");
        }
        return allChecked;
    }


    const handleAppFiltersChange = (id, val) => {
        

        let f = [];
        if(_.isEmpty(appFilters))
            f = _.cloneDeep(dataFilters);    
        else
            f = _.cloneDeep(appFilters);    
        // If it's a switch button from MUI . Here id value correspond to "event" value
        if(typeof id.target !== 'undefined'){
            f[id.target.name] =  id.target.checked;
        }
        else if(
            id == 'oficially_announced' ||
            id == 'budget' ||
            id == 'rate' ||
            id == 'ram' ||
            id == 'screen_display' ||
            id == 'screen_resolution' ||
            id == 'storage' ||
            id == 'camera_front' ||
            id == 'camera_main' ||
            id == 'battery_charge_speed_wireless' ||
            id == 'battery_charge_speed_wired' ||
            id == 'battery_capacity' ||
            id == 'screen_resolution' ||
            id == 'screen_display'
        )
        {
            
            if(typeof f[id] !== 'undefined')
            {
                f[id].first = Math.floor(val[0]);
                f[id].last = Math.ceil(val[1]);
            }
        }
        else {
            f[id] =  val;
        }
        // Update user Filter data
        setAppFilters(f);
        setCurrentPage(1);
    } 

      
    const handlePageChange = page => {
        setCurrentPage(page);
        scrollToTop();
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleChangeOrderBy = (orderBy, orderByDir) => {
        if(orderBy == 'lowest_price' && appFilters.priceStatus.length == 1) {
            setOrderBy(`lowest_price_${appFilters.priceStatus[0].id}`);
        }
        else {
            setOrderBy(orderBy);
        }
        
        setOrderByDir(orderByDir);
        setCurrentPage(1);
    };

    const scrollToTop = () => {
        animateScroll.scrollToTop({
            containerId: "deviceResults",
            duration: 100,
            delay: 50
        });
    };

    const handleAddCompare = (id, imgId) => {
        if(compareDevices.length < 4){
            const newDevice = _.filter(devices, ['id', id]);
            const list = [...compareDevices, _.filter(devices, ['id', id])[0] ];
            setCompareDevices(list);

            const newImg = document.getElementById(imgId).cloneNode(true);
            document.getElementById(imgId).appendChild(newImg);
            //document.getElementById(imgId).insertBefore(newImg, newImg)
        }
        else alert('No se puede comparar más de 4 dispositivos')
    }

    const handleRemoveCompare = (id) => {
        const list  = _.filter(compareDevices, function(c) {
            return c.id !== id;
        });
        setCompareDevices(list);
    }

    const handleSubmitCompare = () => {
        let url = '/dispositivos/comparar/'; 
        if(type == 'smartwatches') url = '/smartwatches/comparar/'
        else if(type == 'mediaplayers')  url = '/reproductores-multimedia/comparar/'
        else if(type == 'headphones')  url = '/auriculares/comparar/'
        compareDevices.map(d => {
            url += d.slug + ',';
        })
        window.location.href = _.trimEnd(url, ',');
    }

    /**
     * Method to get the number of active filters
     */
    const getNbActiveFilters = () => {
        let nb = 0;
        if(searchStatus == 'finished' && !_.isEmpty(appFilters))
        {
            _.forEach(appFilters, function(value, key) {
                if( (   
                        value == true && 
                        !_.isEqual(value, dataFilters[key]) 
                    ) || ( 
                        !_.isEmpty(value) && 
                        !_.isEqual(value, dataFilters[key])
                    ) 
                ) {
                    nb++;  
                } 
            });
        }
        if(nbActiveFilters != nb) setNbActiveFilters(nb);
    }



    const handleResetFilters = () => {
        setResetClick(true);
        setAppFilters(dataFilters);        
        setCurrentPage(1);
        setOrderBy('oficially_announced');
        setOrderByDir('desc');
        setTimeout(function(){
            setResetClick(false);
        }, 500);
    }

    return (
        <>
            
            {(devices.length != 0) ? (

                <React.Fragment>
                
                <div className="row w-100">
                    <div className="col-12 col-lg-3" >
                        <aside className="menubar offcanvas-lg offcanvas-start" tabIndex="-1" id="offcanvasSidebar" aria-labelledby="offcanvasSidebarLabel">
                            <div className="offcanvas-header">
                                <h5 className="offcanvas-title" id="offcanvasSidebarLabel"></h5>
                                <button type="button" className="btn-close" data-bs-dismiss="offcanvas" data-bs-target="#offcanvasSidebar" aria-label="Close"></button>
                            </div>
                            <div className="offcanvas-body d-block">
                                {(typeof devices != "undefined" && devices !== null && devices.length > 0) && (
                                    <Filters 
                                        devices={devices}
                                        dataFilters={dataFilters} 
                                        appFilters={appFilters}
                                        appFiltersChange={handleAppFiltersChange} 
                                        nbActiveFilters={nbActiveFilters}
                                        resetFilters={handleResetFilters}
                                        resetClick={resetClick}
                                        changeOrderBy={handleChangeOrderBy}
                                        orderBy={orderBy}
                                        orderByDir={orderByDir}
                                        type={type}
                                    />
                                )}
                            </div>
                        </aside>
                    </div>
                    {(searchStatus == 'pending') && (
                        <div id="preloaderDark"> 
                                <div id="loader"></div>
                        </div>
                    )}
                    <div className={`col-12 col-lg-9`}>
                    
                        {/* Filter button*/}
                        <div className="d-lg-none text-center">
                            <a className="btn btn-lg btn-outline-primary btn-lg rounded-pill" data-bs-toggle="offcanvas" href="#offcanvasSidebar" role="button" aria-controls="offcanvasSidebar">
                                <svg className="fs-5 bi" fill="currentColor">
                                    <use href="#arrow-bar-right"></use> 
                                </svg> Filtros
                            </a>
                        </div>
        
                        {/* <div className="row px-mob"> */}
                        <div className="row row-cols-1 row-cols-md-2 row-cols-xxl-3 gx-4 gy-5 py-5">
                            {(items.length == 0 && searchStatus != 'pending') && (
                                <div className="col-12 text-center">
                                    <h3>No hay resultados</h3>
                                    <small>Prueba quitando o modificando algunos filtros.</small>
                                </div>
                            )}
                            {(!_.isEmpty(items)) && (
                                <>
                                    {items.map( (item, index) => (
                                        <React.Fragment key={`deviceBox-${index}`} >
                                            {(type == 'smartwatches') && (
                                                <SmartwatchBox 
                                                    item={item}
                                                    addCompare={handleAddCompare} 
                                                    compareDevices={compareDevices}
                                                    removeCompare={handleRemoveCompare}
                                                    priceStatus={appFilters.priceStatus}
                                                    devices={devices}
                                                />
                                            )}

                                            {(type == 'smartphones') && (
                                                <DeviceBox 
                                                    item={item}
                                                    addCompare={handleAddCompare} 
                                                    compareDevices={compareDevices}
                                                    removeCompare={handleRemoveCompare}
                                                    priceStatus={appFilters.priceStatus}
                                                    devices={devices}
                                                />
                                            )}

                                            {(type == 'mediaplayers') && (
                                                <MediaPlayerBox 
                                                    item={item}
                                                    addCompare={handleAddCompare} 
                                                    compareDevices={compareDevices}
                                                    removeCompare={handleRemoveCompare}
                                                    priceStatus={appFilters.priceStatus}
                                                    devices={devices}
                                                />
                                            )}

                                            {(type == 'headphones') && (
                                                <HeadphoneBox 
                                                    item={item}
                                                    addCompare={handleAddCompare} 
                                                    compareDevices={compareDevices}
                                                    removeCompare={handleRemoveCompare}
                                                    priceStatus={appFilters.priceStatus}
                                                    devices={devices}
                                                />
                                            )}
                                            
                                        </React.Fragment>
                                    ))}
                                </>
                            )}
                        </div>

                        {(typeof devices != "undefined" && devices !== null && totalItems > 0 && totalItems > pageSize) && (
                            <div className="row">
                                <div className="col-12 text-center">
                                    <Pagination
                                        itemsCount={totalItems}
                                        pageSize={pageSize}
                                        radiusPages={3}
                                        onPageChange={handlePageChange}
                                        currentPage={currentPage}
                                    />
                                    {/* itemsCOunt : {devices.length}<br/>
                                    pageSize : {pageSize}<br/>
                                    currentPage : {currentPage}<br/>
                                    totalItems : {totalItems}<br/> */}
                                </div>
                            </div>
                        )}

                    </div>
                </div>

            
                <div className="fixed-bottom d-flex justify-content-center justify-content-lg-end" style={{bottom:75, zIndex : 1000}}>
                    {(compareDevices.length > 0) ? (
                        <button type="button" className="btn btn-primary position-relative fw-bold" onClick={handleClickOpen}>
                            Comparar {compareDevices.length} dispositivo(s)
                            <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                {compareDevices.length}
                                <span className="visually-hidden">Nº de dispositivos a comparar</span>
                            </span>
                        </button>
                        // <Badge badgeContent={compareDevices.length} color="primary">
                        //     <Button variant="contained" color="secondary" onClick={handleClickOpen}>
                        //             Comparar {compareDevices.length} dispositivos
                        //     </Button>
                        // </Badge>
                    ) : null }
                </div>
               
                <DialogCompareList 
                    compareDevices={compareDevices}
                    open={open} 
                    close={handleClose} 
                    submitCompare={handleSubmitCompare}
                    removeCompare={handleRemoveCompare}
                />

                
            </React.Fragment>
            ) : (
                // <div className="row  w-100">
                //     <div className="col-12 text-center" >
                //         <CircularProgress />
                //     </div>
                // </div>
                <>
                    <div className="col-12 col-xl-3 d-none d-xl-block">
                        {[...Array(6)].map((_, i) => (
                        <div className="card mb-4" aria-hidden="true" key={i}>
                            <div className="card-header">
                                <h5 className="card-title placeholder-glow">
                                    <span className="placeholder col-8"></span>
                                </h5>
                            </div>
                            <div className="card-body placeholder-glow">
                                <span className="placeholder col-7"></span>
                                <span className="placeholder col-4"></span>
                                <span className="placeholder col-4"></span>
                                <span className="placeholder col-6"></span>
                                <span className="placeholder col-8"></span>
                            </div>
                        </div>
                        ))}
                    </div>

                    <div className="col-12 col-xl-9">
                        <button style={{ position: 'fixed', bottom: '0px', left: '3px' }} id="btnOffCanvas" className="d-lg-none btn btn-bordered mb-3" type="button" data-toggle="offcanvas">Filtros <i className="fas fa-arrow-right"></i></button>

                        <div className="row row-cols-1 row-cols-md-3 gx-3 gy-5 mb-4">
                        {[...Array(18)].map((_, i) => (
                            <DeviceCard key={i} />
                        ))}
                        </div>
                    </div>
                </>
            )}   
        </>             
    );
}

export default Results;

function DeviceCard({ device }) {
    return (
        <div className="col">
            <div className="card" aria-hidden="true">
                <div className="card-body">
                    <h5 className="card-title placeholder-glow text-center">
                        <span className="placeholder col-10"></span>
                    </h5>
                    <div className="d-flex justify-content-between placeholder-glow">
                        <div className="placeholder rounded" style={{ width: '130px', height: '250px' }}>
                        </div>
                        <div className="w-50" style={{ width: '130px', height: '250px' }}>
                            <p className="card-text placeholder-glow">
                                <span className="placeholder col-7"></span>
                                <span className="placeholder col-4"></span>
                                <span className="placeholder col-4"></span>
                                <span className="placeholder col-6"></span>
                                <span className="placeholder col-8"></span>
                            </p>
                            <a className="btn btn-primary disabled placeholder col-10"></a>
                        </div>
                    </div>
                </div>
                <div className="card-footer d-flex justify-content-between">
                    <a className="btn btn-danger disabled placeholder col-5"></a>
                    <a className="btn btn-primary disabled placeholder col-5"></a>
                </div>
            </div>
        </div>
    );
}
